import {css} from 'styled-components';
import {switchProp} from 'styled-tools';

const fullWidthStyle = css`
  width: 100%;
  text-align: center;
`;

const mdStyle = css`
  padding: 16px 24px;
`;

const smStyle = css`
  padding: 12px 16px;
`;

const xmStyle = css`
  padding: 6px;
`;

const xsStyle = css`
  padding: 10px 16px;
`;

export const width = css`
  ${switchProp(
    'width',
    {
      xm: xmStyle,
      sm: smStyle,
      md: mdStyle,
      xs: xsStyle,
      full: fullWidthStyle,
    },
    mdStyle,
  )}
`;
